import OUTDOORLogo from "../images/OUTDOOR-logo.svg";
import indexStyles from "../scss/footer-outdoor.scss";
import { FeatureSet } from "../../common/features";
import { regearRedirect } from "../helpers/regearRedirect";
import { EMAIL_SIGNUP } from "../constants/links";
import { returnsLinks } from "../components/FooterLinks";

const orderStatusUrl = "/account/order-status";
const viewProfileUrl = "/account/view-profile";
const cookieCenterUrl = `${window.location.href.replace(/#cookie-preference-center/g, "")}#cookie-preference-center`;
const findStoreBuyNowStr = data => data["$^FindAStoreBuyNow^$"];

const logo = data => `
  <ul class="logo">
    <li>
      <a data-analyticsLabel="Arcteryx Logo" data-linkid="footer:logo" data-url="arcteryx.com" href="/" title="Arc'teryx"><span>Arc'teryx</span>${OUTDOORLogo}</a>
    </li>
  </ul>`;

const contact = data => `
  <ul class="contact CN-block">
    <li><a data-analyticsLabel="Customer Support Centre" data-linkid="footer:help" data-analyticsLabel="" data-url="arcteryx.com/help" href="/help">${data["Customer Support Centre"]}</a></li>
    <li class="contact-phone" style="display:none"><span class="tel-number"  data-number="${data.phoneNumber}">${data.phoneNumber}</span></li>
    <li><a data-analyticsLabel="Contact Us" data-linkid="footer:contact" data-url="arcteryx.com/help/contact" href="/help/contact">${data["$^ContactUs^$"]}</a></li>
    <li>
      <a data-analyticsLabel="General FAQ" data-linkid="footer:faq" data-url="arcteryx.com/help/faq" class="virtual-advisor-enabled" href="/help/faq">${data["General FAQ"]}</a>
      <a data-analyticsLabel="Recall Info" data-linkid="footer:recall" data-url="recall.arcteryx.com" class="virtual-advisor-disabled" href="//recall.arcteryx.com" class="recall-link">${data["$^footer-recall-info^$"]}</a>
     </li>
  </ul>`;

const orders = data => `
  <ul class="orders CN-block">
    <li>
      <a data-analyticsLabel="Shipping and Delivery" data-linkid="footer:shipping" data-url="arcteryx.com/help/shipping" href="/help/shipping">${
        data["Shipping & Delivery"]
      }</a>
    </li>
    <li>
      <a data-analyticsLabel="Order Tracking" data-linkid="footer:order-status" data-url="arcteryx.com${orderStatusUrl}" href="${orderStatusUrl}" class="isLoggedIn">${
  data["Order Tracking"]
}</a>
      <a data-analyticsLabel="Order Tracking" data-linkid="footer:order-tracking" data-url="arcteryx.com/help/order-tracking" href="/help/order-tracking" class="notLoggedIn">${
        data["Order Tracking"]
      }</a>
    </li>
    ${returnsLinks(data, "outdoor")}
  </ul>`;

const faq = data => `
  <ul class="faq">
    <li><a data-analyticsLabel="Sustainability" data-linkid="footer:sustainability" data-url="arcteryx.com/explore/sustainability" href="/explore/sustainability">${data["$^nav-sustainability^$"]}</a></li>
    <li><a data-analyticsLabel="Who We Are" data-linkid="footer:whoweare" data-url="arcteryx.com/explore/whoweare" href="/explore/whoweare">${data["$^nav-whoweare^$"]}</a></li>
    <li class=" CN-block"><a data-analyticsLabel="Pro Program" data-linkid="footer:pro" data-url="arcteryx.com/shop/pro" href="/shop/pro">${data["$^footer-pro-program^$"]}</a></li>
  </ul>`;

const company = data => `
  <ul class="company">
    <li class=""><a data-analyticsLabel="Gift Cards" data-linkid="footer:giftcards" data-url="arcteryx.com/giftcards" href="/giftcards">${
      data["$^nav-giftCards^$"]
    }</a></li>
    <li class=""><a data-analyticsLabel="Careers" data-linkid="footer:careers" data-url="arcteryx.com/careers" href="/careers">${
      data["$^footer-nav-careers^$"]
    }</a></li>
    <li class=""><a data-analyticsLabel="Newsroom" data-linkid="footer:newsroom" data-url="blog.arcteryx.com/news" href="//blog.arcteryx.com/news" target="blank">${
      data["$^Newsroom^$"]
    }</a></li>
    <li class="" style="display:none;"><a data-analyticsLabel="Find A Store" data-linkid="footer:find-a-store" data-url="arcteryx.com/stores/find-a-store" href="/stores/find-a-store">${findStoreBuyNowStr(
      data
    )}</a></li>
  </ul>`;

const social = data => `
  <div class="social">
    <a data-analyticsLabel="My Account" data-linkid="footer:view-profile" data-url="arcteryx.com${viewProfileUrl}" class="account logOut CN-block" href="${viewProfileUrl}">${data["My Account"]}</a>
    <a data-analyticsLabel="Sign-In" data-linkid="footer:account-login" data-url="arcteryx.com/account/login" class="logIn CN-block" href="/account/login"><span class="text">${data["Sign-In"]}</span></a>
    <div class="footer-ftue">
      <span class="flag"></span>
      <span class="text lang-selector"> <span class="country"></span> / <span class="language"></span></span>
    </div>

    <div class="app-wrap">
      <div>
        <a data-analyticsLabel="iOS App" data-linkid="footer:iOS App" data-url="https://apps.apple.com/app/arcteryx/id1183113553" class="arcapp arc-ios-app CN-block " href="https://apps.apple.com/app/arcteryx/id1183113553" target="_blank" rel="noopener"><span class="text">${data["iOS App"]}</span> / </a>
        <a data-analyticsLabel="Android App" data-linkid="footer:Android App" data-url="https://play.google.com/store/apps/details?id=com.arcteryx.customer" class="arcapp arc-android-app CN-block " href="https://play.google.com/store/apps/details?id=com.arcteryx.customer" target="_blank" rel="noopener">
          <span class="text">${data["Android App"]}</span>
        </a>
      </div>
    </div>

    <div class="social-wrap">
      <ul>
        <li>
          <a data-analyticsLabel="Facebook" data-linkid="footer:facebook" data-url="www.facebook.com/arcteryx" href="//www.facebook.com/arcteryx" class="social-na facebook" target="_blank" title="Facebook" rel="noopener">
            <span class="footer__social-share">Facebook</span>
          </a>
        </li>
        <li>
          <a data-analyticsLabel="Instagram" data-linkid="footer:instagram" data-url="instagram.com/arcteryx" href="//instagram.com/arcteryx" class="social-na instagram" target="_blank" title="Instagram" rel="noopener">
            <span class="footer__social-share">Instagram</span>
          </a>
        </li>
        <li>
          <a data-analyticsLabel="Twitter" data-linkid="footer:twitter" data-url="twitter.com/arcteryx" href="//twitter.com/arcteryx" class="social-na twitter" target="_blank" title="Twitter" rel="noopener">
            <span class="footer__social-share">Twitter</span>
          </a>
        </li>
        <li>
          <a data-analyticsLabel="Pinterest" data-linkid="footer:pinterest" data-url="www.pinterest.com/arcteryx" href="//www.pinterest.com/arcteryx" class="social-na pinterest" target="_blank" title="Pinterest" rel="noopener">
            <span class="footer__social-share">Pinterest</span>
          </a>
        </li>
        <li>
          <a data-analyticsLabel="YouTube" data-linkid="footer:youtube" data-url="www.youtube.com/arcteryxequipmentinc" href="//www.youtube.com/arcteryxequipmentinc" class="social-na youtube" target="_blank" title="Youtube" rel="noopener">
            <span class="footer__social-share">YouTube</span>
          </a>
        </li>
      </ul>
    </div>
  </div>`;

const mobExplore = (data, language) => `
  <div id="mobExplore">
  <p class="body3">${data["$^explore^$"]}</p>
  <div class="mob-explore">
    <ul>
      <li class="no-wasted-days">
        <a data-analyticsLabel="No Wasted Days" data-linkid="explore:no-wasted-days" data-url="arcteryx.com/explore/no-wasted-days" href="/explore/no-wasted-days">
          No Wasted Days™ 
        </a>
      </li>
      <li class="whoweare">
        <a data-analyticsLabel="Who We Are" data-linkid="explore:who-we-are" data-url="arcteryx.com/explore/whoweare" href="/explore/whoweare">${
          data["$^nav-whoweare^$"]
        }</a>
      </li>
      <li class="blog">
        <a data-analyticsLabel="Blog" data-linkid="explore:blog" data-url="blog.arcteryx.com" href="//blog.arcteryx.com">
          Blog
        </a>
      </li>
      <li class="films CA-only US-only" style='display:none'>
        <a data-analyticsLabel="Films" data-linkid="explore:films" data-url="arcteryx.com/explore/films" href="/explore/films">Films</a>
      </li>
      <li class="community-events">
        <a data-analyticsLabel="Community Events" data-linkid="explore:community-events" data-url="http://community-events.arcteryx.com" href="http://community-events.arcteryx.com">${
          data["$^community-events^$"]
        }</a>
      </li>
      <li class="academy">
        <a data-analyticsLabel="Academies" data-linkid="explore:academy" data-url="arcteryxacademy.com" href="//arcteryxacademy.com">Academies</a>
      </li>
      <li class="athletes">
        <a data-analyticsLabel="Athletes and Ambassadors" data-linkid="explore:athletes" data-url="arcteryx.com/Athletes.aspx" href="/Athletes.aspx">${
          data["Athletes & Ambassadors"]
        }</a>
      </li>
      <li class="athletes CN-block AU-block NZ-block">
        <a data-analyticsLabel="ReBird™" data-linkid="explore:rebird" data-url="arcteryx.com/explore/rebird" href="/explore/rebird">ReBird™</a>
      </li>
      <li class="sustainability">
        <a data-analyticsLabel="Sustainability" data-linkid="explore:sustainability" data-url="arcteryx.com/explore/sustainability" href="/explore/sustainability">${
          data["$^nav-sustainability^$"]
        }</a>
      </li>
      <li class="arc-naming-scheme">
        <a data-analyticsLabel="Arc'teryx Naming Scheme" data-linkid="explore:arc-naming-scheme" data-url="arcteryx.com/help/arc-naming" href="/help/arc-naming">${
          data["$^arc-naming-scheme^$"]
        }</a>
      </li>
      <li class="obsessive-design">
        <a data-analyticsLabel="Obsessive Design" data-linkid="explore:obsessive-design" data-url="arcteryx.com/explore/obsessive-design" href="/explore/obsessive-design">${
          data["Obsessive Design"]
        }</a>
      </li>
      <li class="epe-fabric-sustainability">
        <a data-analyticsLabel="ePE & Fabric Sustainability" data-linkid="explore:epe-fabric-sustainability" data-url="arcteryx.com/shop/epe-fabric" href="/shop/epe-fabric">${
          data["ePE & Fabric Sustainability"]
        }</a>
      </li>
      ${
        language.toLowerCase() === "en"
          ? `<li class="product-advice">
          <a data-analyticsLabel="Arc'teryx Advice" data-linkid="explore:product-advice" data-url="arcteryx.com/product-advice" href="/product-advice">${data["Product Advice"]}</a>
        </li>`
          : ""
      }
    </ul>
  </div>
  </div>
`;

const mobFootwear = data => `
  <div id="mobFootwear">
  <p class="body3">${data.Footwear}</p>
  <div class="mob-footwear">
    <ul>
      <li class="w23_ftw">
        <a data-analyticsLabel="Men's Footwear" data-linkid="footwear:mens-footwear" data-url="arcteryx.com/c/mens/footwear" href="/c/mens/footwear">${data["Men's Footwear"]}</a>
      </li>
      <li class="w23_ftw">
        <a data-analyticsLabel="Women's Footwear" data-linkid="footwear:womens-footwear" data-url="arcteryx.com/c/womens/footwear" href="/c/womens/footwear">${data["Women's Footwear"]}</a>
      </li>

      <li class="footwear_climb">
        <a data-analyticsLabel="Footwear Innovation" data-linkid="footwear:footwear-innovation" data-url="arcteryx.com/shop/footwear" href="/shop/footwear">${data["Footwear Innovation"]}</a>
      </li>
      <li class="f23_footwear_finder">
        <a data-analyticsLabel="Footwear Finder" data-linkid="footwear:footwear-finder" data-url="arcteryx.com/shop/footwear-finder" href="/shop/footwear-finder">${data["$^nav-footwearFinder^$"]}</a>
      </li>
      <li class="obsessive-design">
        <a data-analyticsLabel="Obsessive Design" data-linkid="footwear:obsessive-design" data-url="arcteryx.com/explore/obsessive-design/films" href="/explore/obsessive-design/films">${data["Obsessive Design"]}</a>
      </li>
    </ul>
  </div>
  </div>
`;

const bottomBar = (data, country, language) => `
  <div class="bottom-bar">
  <ul class="site-services">
    <li>    
    <a id="preference-center" data-analyticsLabel="Cookie Preference Centre" data-linkid="footer:cookie-preference-center" data-url=${cookieCenterUrl}> ${
  data["Cookie Preference Centre"]
}</a> |
    <a data-analyticsLabel="Cookie Policy" data-linkid="footer:cookies" data-url="arcteryx.com/help/cookies" href="/help/cookies">${
      data["Cookie Policy"]
    }</a> |
    <a data-analyticsLabel="Privacy Policy" data-linkid="footer:privacy" data-url="arcteryx.com/help/privacy" href="/help/privacy">${
      data["Privacy Policy"]
    }</a> |
    <span class="US-only">
      <a data-analyticsLabel="CA Supply Chains Act" data-linkid="footer:ca-supply-chains-act" data-url="arcteryx.com/help/ca-supply-chains-act" href="/help/ca-supply-chains-act">${
        data["CA Supply Chains Act"]
      }</a> |
    </span>
    <a data-analyticsLabel="Terms and Conditions" data-linkid="footer:terms-and-conditions" data-url="arcteryx.com/help/terms-and-conditions" href="/help/terms-and-conditions">${
      data["Terms & Conditions"]
    }</a> |
    <a data-analyticsLabel="Terms of Use" data-linkid="footer:terms-of-use" data-url="arcteryx.com/help/terms-of-use" href="/help/terms-of-use">${
      data["Terms of Use"]
    }</a> |
    <a data-analyticsLabel="Accessibility" data-linkid="footer:accessibility" data-url="arcteryx.com/help/accessibility" href="/help/accessibility">${
      data.Accessibility
    }</a> |
    <a data-analyticsLabel="Do Not Sell My Personal Information" data-linkid="footer:do-not-sell-my-personal-information" data-url="arcteryx.com/help/privacy#do-not-sell-my-personal-information" href="/help/privacy#do-not-sell-my-personal-information">${
      data["Do Not Sell My Personal Information"]
    }</a>
    <span class="virtual-advisor-enabled">
      <span> | </span><a data-analyticsLabel="Recall Info" data-linkid="footer:recall" data-url="recall.arcteryx.com" href="//recall.arcteryx.com">${
        data["$^footer-recall-info^$"]
      }</a> | 
    </span>
    <a data-analyticsLabel="Sitemap" data-linkid="footer:sitemap" data-url="arcteryx.com/sitemap" href="/sitemap">${
      data["$^footer-sitemap^$"]
    }</a>
    </li>
    <li class="footWebsiteList websiteSelector">
    <select title="Please select a website." class="WebsiteSelector">
      <option value="" data-translation="footer-option-selectWebsite" aria-label="Please select a website."
        title="Please select a website.">Please select a website.</option>
      <option class="outdoor" value="https://arcteryx.com" selected="selected" aria-label="arcteryx" title="arcteryx">Arcteryx.com</option>
      <option class="blog" value="https://blog.arcteryx.com" aria-label="blog" title="blog">blog.arcteryx.com</option>
      <option class="leaf" value="https://leaf.arcteryx.com" data-translation="footer-option-leaf"
        aria-label="law enforcement and armed forces" title="law enforcement and armed forces">LEAF</option>
      <option class="rocksolid" value="https://www.usedgear.arcteryx.com" data-translation="footer-option-usedgear"
        aria-label="usedgear" title="usedgear">usedgear.arcteryx.com</option>
    </select>
    </li>
  </ul>
  <ul class="sites">
    <li class="outdoor selected" data-value="//arcteryx.com">arcteryx.com</li>
    ${
      FeatureSet.enableOutletFlashSaleModal() || country.toLowerCase() === "us"
        ? ""
        : `<li class="outlet CN-block" data-value="//outlet.arcteryx.com"><a data-analyticsLabel="outlet.arcteryx.com" data-linkid="footer:outlet" data-url="outlet.arcteryx.com" href="//outlet.arcteryx.com" target="_blank" rel="noopener">outlet.arcteryx.com</a></li>`
    }
    <li class="blog" data-value="//blog.arcteryx.com"><a data-analyticsLabel="blog.arcteryx.com" data-linkid="footer:blog" data-url="blog.arcteryx.com" href="//blog.arcteryx.com" target="_blank" rel="noopener">blog.arcteryx.com</a></li>
    <li class="leaf" data-value="//leaf.arcteryx.com"><a data-analyticsLabel="leaf.arcteryx.com" data-linkid="footer:leaf" data-url="leaf.arcteryx.com" href="//leaf.arcteryx.com" target="_blank" rel="noopener">leaf.arcteryx.com</a></li>
    <li class="US-only CA-only" data-value="//www.${regearRedirect(
      country,
      language
    )}"><a data-analyticsLabel="${regearRedirect(
  country,
  language
)}" data-linkid="footer:regear" data-url="https://www.${regearRedirect(
  country,
  language
)}" href="https://www.${regearRedirect(country, language)}" target="_blank" rel="noopener">${regearRedirect(
  country,
  language
)}</a></li>
  </ul>
  <ul class="sites">
    <li data-value="//www.amersports.com">Arc’teryx - an <a class="bottom-bar-amer" data-analyticsLabel="Amer Sports" data-linkid="footer:amer" data-url="https://www.amersports.com" href="https://www.amersports.com" target="_blank" rel="noopener" >Amer Sports</a> Brand</li>
  </ul>
  </div>`;

const footerHtml = (data, country, language) => `<div class="OUTDOOR NOTLOGGEDIN">
      <div id="footer">
        <style type="text/css">
          ${indexStyles}
        </style>
        <div id="footerCart" class="footerCart">
          <div class="footer-ftue">
            <span class="flag"></span>
            <span class="country"></span> / <span class="language"></span>
          </div>
        </div>
        <div id="footerContent" class="footerContentHome">
          <div class="grid-container">
            <div class="info find-a-store">
              <a data-analyticsLabel="Find An Arc'teryx Store" data-linkid="footer:find-a-store" data-url="arcteryx.com/stores/find-a-store" href="/stores/find-a-store" class=""><span class="feature-text">${
                data["$^footer-findArcStore^$"]
              }</span></a>
              <p>${data["$^footer-locateBrandStoreOrPartner^$"]}</p>
              <a data-analyticsLabel="Find A Store" data-linkid="footer:find-a-store" data-url="arcteryx.com/stores/find-a-store" href="/stores/find-a-store" class="sublink ">${findStoreBuyNowStr(
                data
              )}</a>
            </div>
            <div class="info customer-form">
              <a data-analyticsLabel="BE THE FIRST TO KNOW" target="_blank" data-linkid="footer:email-signup" data-url="arcteryx.com${EMAIL_SIGNUP}" href="${EMAIL_SIGNUP}" style="cursor: pointer">
                <span class="feature-text">${data["$^SignUpTitle^$"]}</span>
              </a>

              <p>${data["$^SignUpBodyCopy2^$"]}</p>

              <a data-analyticsLabel="SIGN UP FOR EMAILS" target="_blank" data-linkid="footer:email-signup" data-url="arcteryx.com${EMAIL_SIGNUP}" href="${EMAIL_SIGNUP}" tabindex="0" class="sublink" style="cursor: pointer">
                ${data["$^SignUpCta2^$"]}
              </a>
            </div>
            <div class="info customer-service-centre">
              <a data-analyticsLabel="Customer Support Centre" data-linkid="footer:help" data-url="arcteryx.com/help" href="/help" tabindex="0"><span class="feature-text">${
                data["Customer Support Centre"]
              }</span></a>
              <p>${data["$^footer-newMoreInfoHelp^$"]}</p>
              <a data-analyticsLabel="Find Answers" data-linkid="footer:help" data-url="arcteryx.com/help" href="/help" tabindex="0" class="sublink">${
                data["$^nav-find-answers^$"]
              }</a>
            </div>
          </div>
          ${mobExplore(data, language)}
          ${mobFootwear(data)}
          <div class="footerMenu">
            <div class="footerContainer">
              <!--////////// LOGO ///////////-->
              ${logo(data)}
              <!--////////// Contact ///////////-->
              ${contact(data)}
              <!--////////// Orders ///////////-->
              ${orders(data)}
              <!--////////// FAQ ///////////-->
              ${faq(data)}
              <!--////////// Company ///////////-->
              ${company(data)}
              <!--////////// SOCIAL ///////////-->
              ${social(data)}
            </div>
          </div>
          <div style="clear: both;">
            <!--//-->
          </div>
          ${bottomBar(data, country, language)}
        </div>
      </div>
    </div>`;

export default footerHtml;
